export default __webpack_public_path__ + "static/brand-8b35a8edd677232007d8fbf5c1c07eaa.png";